import { Link } from "react-router-dom";
import { formatDate } from "../../../utils/date";
import { cx } from "../../../utils/classNames";
import ui from "../../../components/ui/ui.module.css";
import styles from "../Dashboard.module.css";

const AssetsCard = ({ assets }) => (
  <>
    <div className={styles.stats}>
      <Link to="/me/assets" className={cx(styles.stat, styles.statLink)}>
        <div className={styles.statValue}>{assets.activeCount}</div>
        <div className={styles.statLabel}>Assigned to me</div>
      </Link>
      <Link to="/me/assets" className={cx(styles.stat, styles.statLink)}>
        <div
          className={cx(
            styles.statValue,
            assets.pendingAcknowledgement > 0 && "text-warning",
          )}
        >
          {assets.pendingAcknowledgement}
        </div>
        <div className={styles.statLabel}>To acknowledge</div>
      </Link>
    </div>

    {assets.dueSoon.length > 0 ? (
      <>
        <h6 className={styles.subheading}>Due back soon</h6>
        <ul className={styles.miniList}>
          {assets.dueSoon.map((a) => (
            <li key={a.assignmentId}>
              <span>
                <strong>{a.name}</strong>{" "}
                <span className={ui.muted}>{a.assetTag}</span>
              </span>
              <span className={cx(a.isOverdue && styles.overdue)}>
                {a.isOverdue ? "Overdue · " : "Return by "}
                {formatDate(a.expectedReturnDate)}
              </span>
            </li>
          ))}
        </ul>
      </>
    ) : (
      <p className={cx(ui.muted, "mb-0")}>
        No assets due back in the next 14 days.
      </p>
    )}
  </>
);

export default AssetsCard;
